import React from 'react';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import clsx from 'clsx';
import classes from './Sorter.module.scss';

const Sorter = ({ direction }) => {
  return (
    <span className={classes.wrapper}>
      <span className={clsx(classes.carper, { [classes.asc]: direction === 'asc' })}>
        <ArrowDropUpIcon />
      </span>
      <span
        className={clsx(classes.carper, classes.down, { [classes.desc]: direction === 'desc' })}>
        <ArrowDropDownIcon />
      </span>
    </span>
  );
};
export default Sorter;
